<template>
    <div v-if="hasChart">
        <div class="tw-flex tw-mb-4 tw-items-center tw-justify-center tw-text-xs tw-text-gray-400">
            <div class="tw-mt-4 tw-px-4">
                <span
                    class="tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-indigo-500 tw-mr-2"
                />
                {{ $t("meetings.analytics.insights.chart.labelIndividual") }}
            </div>
            <div class="tw-mt-4 tw-px-6">
                <span
                    class="tw-inline-block tw-h-2 tw-w-2 tw-rounded-full tw-bg-indigo-200 tw-mr-2"
                />
                {{ $t("meetings.analytics.insights.chart.labelTeam") }}
            </div>
        </div>
        <l-chart
            v-if="highestTimelineDate && lowestTimelineDate"
            :options="chartOptions"
            :colors="['primary', 'primaryLow']"
            :data="{
                labels: [],
                datasets: [
                    {
                        data: fillTimeSeriesData(
                            timelines.timelineIndividual,
                            $moment,
                            365,
                            highestTimelineDate,
                            lowestTimelineDate,
                        ),
                        maxBarThickness: 12,
                    },
                    {
                        data: fillTimeSeriesData(
                            timelines.timelineTeam,
                            $moment,
                            365,
                            highestTimelineDate,
                            lowestTimelineDate,
                        ),
                        maxBarThickness: 12,
                    },
                ],
            }"
            type="bar"
            :height="`${height}`"
        />
    </div>
</template>

<script>
import LChart from "@/components/LChart";

import fillTimeSeriesData from "@/utils/fill-timeseries-data";

export default {
    components: {
        LChart,
    },
    props: {
        timeUnit: {
            type: String,
            default: "month",
        },
        timelines: {
            type: Object,
            default: () => ({}),
        },
        height: {
            type: Number,
            default: 180,
        },
    },
    data() {
        return {
            chartOptions: Object.freeze({
                responsive: true,
                maintainAspectRatio: false,
                fullWidth: true,
                title: {
                    display: false,
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    displayColors: true,
                    callbacks: {
                        mode: "x",
                    },
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            offset: true,
                            type: "time",
                            display: true,
                            time: {
                                unit: this.timeUnit,
                            },
                            ticks: {
                                fontColor: "#9CA3AF",
                                fontSize: 10,
                            },
                            gridLines: {
                                display: false,
                                color: "#F9FAFB",
                            },
                        },
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            offset: true,
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                fontSize: 10,
                                callback: function(value) {
                                    if (value % 1 === 0) {
                                        return value;
                                    }
                                },
                                fontColor: "#9CA3AF",
                            },
                            gridLines: {
                                color: "#F9FAFB",
                            },
                        },
                    ],
                },
            }),
        };
    },
    computed: {
        hasChart() {
            return (
                this.timelines?.timelineTeam?.length || this.timelines?.timelineIndividual?.length
            );
        },
        lowestTimelineDate() {
            if (!this.hasChart) return null;

            const dates = [];
            const date1 = this.timelines?.timelineTeam?.[this.timelines.timelineTeam.length - 1];
            const date2 = this.timelines?.timelineIndividual?.[
                this.timelines.timelineIndividual.length - 1
            ];
            if (date1) dates.push(this.$moment(date1.t));
            if (date2) dates.push(this.$moment(date2.t));

            return this.$moment.min(dates);
        },
        highestTimelineDate() {
            if (!this.hasChart) return null;

            const dates = [];
            const date1 = this.timelines?.timelineTeam?.[0];
            const date2 = this.timelines?.timelineIndividual?.[0];
            if (date1) dates.push(this.$moment(date1.t));
            if (date2) dates.push(this.$moment(date2.t));

            return this.$moment.max(dates);
        },
    },
    methods: {
        fillTimeSeriesData,
    },
};
</script>
